<template>
  <article class="icon-card" :class="{ compact }">
    <div class="icon-bubble">{{ icon }}</div>
    <h3>{{ title }}</h3>
    <p>{{ text }}</p>
  </article>
</template>

<script>
export default {
  name: 'IconCard',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    text: { type: String, required: true },
    compact: { type: Boolean, default: false }
  }
};
</script>
